var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "233.333 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.627,
    cy: 226.315,
    fill: "#f2f2f2",
    stroke: "null",
    strokeWidth: 0.034,
    rx: 112.683,
    ry: 104.542
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "null",
    strokeWidth: 0.002,
    d: "M515.794 235.066c0 16.607-14.942 30.086-33.334 30.086-18.408 0-33.672-13.483-33.334-30.086.443-22.272 18.78-31.344 33.334-56.943 15.451 24.759 33.334 40.335 33.334 56.943Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 210.749,
    height: 6.014,
    x: 376.16,
    y: -59.083,
    rx: 0.292,
    ry: 0.292,
    style: {
      stroke: "#000",
      transformOrigin: "483.372px -56.3453px"
    },
    transform: "matrix(.78486 -.61967 -.6977 -.72325 1.569 281.91)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryIcon);
export default __webpack_public_path__ + "static/media/dryIcon.f7659e5249602a48009a77704839f49b.svg";
export { ForwardRef as ReactComponent };